'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.Event = /*#__PURE__*/function () {
  function Event(sender) {
    (0, _classCallCheck2["default"])(this, Event);
    this._sender = sender;
    this._listeners = [];
  }
  return (0, _createClass2["default"])(Event, [{
    key: "attach",
    value: function attach(obj, fn) {
      var that = this;
      var listener = {
        obj: obj,
        fn: fn,
        destroy: function destroy() {
          that.detach(this);
        }
      };
      this._listeners.push(listener);
      return listener;
    }
  }, {
    key: "detach",
    value: function detach(listener) {
      var listeners = this._listeners || [];
      var index = listeners.indexOf(listener);
      if (index > -1) {
        return listeners.splice(index, 1);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var listeners = this._listeners;
      while (listeners.length) {
        listeners.pop().destroy();
      }
    }
  }, {
    key: "notify",
    value: function notify() {
      var args = arguments;
      this._listeners.slice().forEach(function (listener) {
        try {
          listener.fn.apply(listener.obj, args);
        } catch (e) {
          console.warn(e, listener, listener.fn);
        }
      });
    }
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return !!this._listeners.length;
    }
  }]);
}();